export function linkFile(moduleName: string) {
	if (moduleName.includes("'"))
		throw new TypeError(`module name is illegal: ( "${moduleName}" )`);

	return `import * as csf from '${moduleName}';
export default csf;
`;
}
